import { observeRequest } from '../helpers/api'
import { BehaviorSubject } from 'rxjs'
import { map, catchError } from 'rxjs/operators'
import { find, reject } from '../libraries/lodash'
import { URL_SHORTENER } from '../constants/urls'
import { RESPONSE_BADRESPONSE, RESPONSE_PENDING } from '../constants/responses'
import { isValidResponse } from '../helpers/dataflow'
import Route from 'route-parser'

const shortenerObserveRequest = observeRequest({ forbiddenAllowed: false })

class ShortenerSubject extends BehaviorSubject {
  constructor () {
    super([])
  }

  has (a) {
    return !!find(this.value, ShortenerSubject.filter(a))
  }

  update = ({ short, long }) => {
    const elements = reject(this.value, ShortenerSubject.filter({ short, long }))
    this.next([...elements, { short: short || RESPONSE_PENDING, long: long || RESPONSE_PENDING }])
  }

  observe (a) {
    return this.pipe(map(list => find(list, ShortenerSubject.filter(a)) || {}))
  }

  remove ({ short, long }) {
    this.next(reject(this.value, ShortenerSubject.filter({ short, long })))
  }

  static filter ({ short, long }) {
    return (e) => (e.short && e.short === short) || (e.long && e.long === long)
  }
}

const Store = new ShortenerSubject()
const route = new Route(URL_SHORTENER)

export const shorten = function (long) {
  if (!Store.has({ long })) {
    Store.update({ long })
    shortenerObserveRequest({ url: route.reverse({}), method: 'post', body: long }).pipe(
      map(response => {
        return isValidResponse(response)
          ? JSON.parse(response)
          : { long, short: response }
      }
      ),
      catchError(e => Store.remove({ long })),
      map(x => Store.update(x))
    ).subscribe(() => {}) // Do we need this subscription? If we do maybe we can close it immediately?
  }

  return Store.observe({ long }).pipe(map(x => x.short))
}

export const expand = function (short) {
  if (!Store.has({ short })) {
    Store.update({ short })
    shortenerObserveRequest({ url: route.reverse({ short }) })
      .pipe(
        map(JSON.parse),
        catchError(e => Store.update({ short, long: RESPONSE_BADRESPONSE })),
        map(r => isValidResponse(r) ? r : { short, long: r }),
        map(x => Store.update(x))
      ).subscribe(() => {}) // Same as above, do we need this subscription? If we do maybe we can close it immediately?
  }

  return Store.observe({ short }).pipe(map(x => x.long))
}
